import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Alert, AlertDescription } from "./ui/alert";
import { 
  BarChart3, 
  Download, 
  RotateCcw, 
  AlertCircle,
  CheckCircle
} from "lucide-react";

const ScheduleH1Details = ({ calculationId, contracts, allocationResults }) => {
  const [loading, setLoading] = useState(false);
  const [scheduleH1Data, setScheduleH1Data] = useState(null);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <BarChart3 className="h-5 w-5 text-green-600" />
            <span>Schedule H-1 - Contract Details</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center py-8">
          <BarChart3 className="h-16 w-16 mx-auto mb-4 text-slate-300" />
          <h3 className="text-lg font-medium mb-2 text-slate-600">Schedule H-1 Not Generated</h3>
          <p className="text-sm text-slate-500 mb-4">
            Generate Schedule H-1 to view detailed line-item contract cost breakdowns.
          </p>
          <Button className="bg-green-600 hover:bg-green-700">
            <BarChart3 className="h-4 w-4 mr-2" />
            Generate Schedule H-1
          </Button>
        </CardContent>
      </Card>

      <div className="p-4 bg-slate-50 rounded-lg">
        <div className="flex items-center space-x-2 text-sm text-slate-600">
          <AlertCircle className="h-4 w-4" />
          <div>
            <p className="font-medium">Schedule H-1 Information</p>
            <ul className="text-xs mt-1 space-y-1">
              <li>• Detailed Breakdown: Line-item level contract costs by element type</li>
              <li>• Cost Categories: Direct Labor, Materials, Subcontracts, and Indirect costs</li>
              <li>• DCAA Compliance: Detailed view supporting Schedule H summary</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleH1Details;